/*
 * Copyright (c) 2010, 2023 BSI Business Systems Integration AG
 *
 * This program and the accompanying materials are made
 * available under the terms of the Eclipse Public License 2.0
 * which is available at https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 */
import {CompositeFieldAdapter, Event, SplitBox, SplitBoxPositionChangeEvent} from '../../../index';

export class SplitBoxAdapter extends CompositeFieldAdapter {

  constructor() {
    super();
    this._addRemoteProperties(['collapsibleField', 'fieldCollapsed', 'minSplitterPosition', 'fieldMinimized']);
  }

  protected _onWidgetPositionChange(event: SplitBoxPositionChangeEvent) {
    this._send('setSplitterPosition', {
      splitterPosition: event.position
    });
  }

  protected override _onWidgetEvent(event: Event<SplitBox>) {
    if (event.type === 'positionChange') {
      this._onWidgetPositionChange(event as SplitBoxPositionChangeEvent);
    } else {
      super._onWidgetEvent(event);
    }
  }
}
